<template>
  <div class="row mx-0">
    <div v-for="(item, index) in dynamicPath" :key="index" class="d-flex">
      <el-tooltip
        :content="item.label"
        :disabled="!Boolean(hoveredItems[index])"
      >
        <small
          class="px-0"
          :class="[
            'mw-node-card-bc-link',
            index + 1 === dynamicPath.length ? 'mw-node-card-bc-link-last' : '',
          ]"
          @click="
            index + 1 === dynamicPath.length ? '' : navigateToItem(item, $event)
          "
          @mouseenter="handleItemHover($event, index)"
          @mouseleave="handleMouseLeave(index)"
        >
          {{ item.label }}
        </small>
      </el-tooltip>
      <small
        class="mx-2 mw-node-card-bc-separator"
        v-if="index !== dynamicPath.length - 1"
        >-</small
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'NavigationBreadcrumb',
  props: {
    bcPath: Array,
  },
  data() {
    return {
      showFullParents: false,
      hoveredItems: [],
    };
  },
  computed: {
    dynamicPath() {
      if (!this.bcPath.length) return [{ label: this.$t('mayday-web.search') }];

      if (this.showFullParents) {
        return this.bcPath;
      } else {
        let dPath = [...this.bcPath];
        if (dPath.length > 4) {
          return dPath
            .slice(0, 2)
            .concat([{ id: -1, label: '...' }])
            .concat(dPath.slice(-2));
        }
        return dPath;
      }
    },
  },
  methods: {
    handleItemHover(e, index) {
      const element = e.target;
      if (element.offsetWidth < element.scrollWidth) {
        const copy = [...this.hoveredItems];
        copy[index] = true;
        this.hoveredItems = copy;
      }
    },
    handleMouseLeave(index) {
      const copy = [...this.hoveredItems];
      copy[index] = false;
      this.hoveredItems = copy;
    },
    navigateToItem(item, e) {
      if (item.id === -1) return (this.showFullParents = true);

      const { contentId } = this.$route.params;

      const payload = {
        query: { source: 'navigation' },
        open: e.metaKey || e.ctrlKey,
      };

      if (item && item.type) {
        payload.entityId = item.id;
        payload.entityType = item.type;
        payload.parentId = contentId;
      } else {
        payload.entityId = item.id;
        payload.entityType = 'Case';
      }

      this.goToWebTranslatedEntity(payload);
    },
    ...mapActions('webKnowledgeModule', ['goToWebTranslatedEntity']),
  },
  watch: {
    bcPath(val) {
      if (val.length <= 4) this.showFullParents = false;
    },
  },
};
</script>

<style lang="scss" scoped>
small {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
}
.mw-node-card-bc-separator {
  color: $grey-5-mayday;
}
.mw-node-card-bc-link-last {
  font-weight: 700;
  opacity: 1;
  color: var(--font-color);
}

.mw-node-card-bc-link-last:hover {
  font-weight: 900;
}

.mw-node-card-bc-link {
  cursor: pointer;
  color: $grey-4-mayday;
  &:hover {
    color: $grey-5-mayday;
  }
}
</style>
